import { ViewFactory } from 'wdc-cube-react'
import SerasaScope, { HeaderScope } from '../serasa.scopes'
import SerasaView from './serasa.view'
import HeaderView from './serasa.header'

export function registerViews(rv = ViewFactory.register) {
    rv(SerasaScope, SerasaView)
    rv(HeaderScope, HeaderView)
}
